import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import AppTheme from './theme/AppTheme';
import AppRoutes from './AppRoutes';
import './App.css';

function App(props: any): React.ReactElement {
  return (
    <ThemeProvider theme={AppTheme}>
      <CssBaseline />
      <AppRoutes {...props} />
    </ThemeProvider>
  );
}

export default App;
